import React from 'react';
import PropTypes from 'prop-types';

import TicketMessage from './TicketMessage';
import PlTicketMessage from '../Placeholders/PlTicketMessage';

const TicketMessages = ({ messages, placeholderLength }) => (
  <div className="sp-help-center">
    {Array.from({ length: placeholderLength }).map((_, index) => (
      <PlTicketMessage key={index} />
    ))}
    {messages && messages.map(el => (
      <TicketMessage key={el.id} message={el} />
    ))}
  </div>
);

TicketMessages.propTypes = {
  // Optional, not oneOfType([..., undefined]): `undefined` is not a validator,
  // and .isRequired contradicted the intent anyway. Both renders guard with
  // `messages && messages.map(...)`, so an absent prop is legitimate.
  messages: PropTypes.arrayOf(PropTypes.object.isRequired),
  placeholderLength: PropTypes.number.isRequired,
};

TicketMessages.defaultProps = {
  messages: null,
};

export default TicketMessages;
